import React, { useState, useRef } from 'react'
import {
  Card,
  Table,
  message,
  Form,
  Modal,
  InputNumber,
  Button,
  Row,
  Col,
  DatePicker,
  Select,
  Upload,
  Input,
  AutoComplete,
  Spin,
  Tooltip,
  Tag
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import { useHistory } from 'react-router-dom'
import UploadOutlined from '@ant-design/icons/lib/icons/UploadOutlined'
import moment from 'moment'
import { SearchOutlined } from '@ant-design/icons'
import { loadData } from '../../../appRedux/actions/Setting'
import { useStore, useDispatch, useSelector } from 'react-redux'
import { userLogOut } from '../../../appRedux/actions/Auth'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { PRICEBOOK } from '../../../constants/Pages'
import {
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck,
  customParse,
  parseFloatCustom,
  getRandomInt,
  dynamoParse
} from '../../../appRedux/actions/GlobalMethods'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import ProductSearch from '../../../components/ProductSearch'
import {
  StringIsNullOrEmpty,
  getDecryptID,
  loadSearchSelectedProduct
} from '../../../appRedux/actions'
import DuplicatePriceBook from './DuplicatePriceBook'
import AdjustPriceBookPrices from './AdjustPriceBookPrices'
import NotAllowedComponent from '../../../components/NotAllowedComponent'

const { Option } = Select

//const scroll = React.createRef();
const scrollToRef = ref => window.scrollTo(0, 0)
//const Option = AutoComplete.Option;
//const OptGroup = AutoComplete.OptGroup;
let key = 0

const confirm = Modal.confirm
//let id = window.location.pathname.split('/')[5];

//create your forceUpdate hook
function useForceUpdate () {
  const [value, setValue] = React.useState(0) // integer state
  return () => setValue(value => value + 1) // update state to force render
  // An function that increment 👆🏻 the previous state like here
  // is better than directly setting `value + 1`
}

const AddEditPriceProd = ({ match }) => {
  const store = useStore()
  const dispatch = useDispatch()
  const history = useHistory()
  const [form] = Form.useForm()
  const forceUpdate = useForceUpdate()
  const  priceBookId = window.location.href.includes("customprices/") ? window.location.href.split("customprices/")[1] : "";

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getIsTaxExclusive = useSelector(
    ({ MainSale }) => MainSale.getIsTaxExclusive
  )
  const getDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getSearchSelectedProduct = useSelector(
    ({ Products }) => Products.searchSelectedProduct
  )

  const [isLoading, setIsLoading] = React.useState(true)
  const [isSpinningLoading, setSpinningLoading] = React.useState(true)
  const [isProductTableSpinning, setIsProductTableSpinning] =
    React.useState(false)
  const [getTableData, setTableData] = React.useState([])
  const [getOutletData, setOutletData] = React.useState([])
  const [getCustomersData, setCustomersData] = React.useState([])
  const [getBookName, setBookName] = React.useState('')
  const [options, setOptions] = useState([])
  const [getSearchProd, setSearchProd] = useState([])
  const [selected, setselected] = useState('')
  const [scroll, setScroll] = React.useState(false)
  const [toRemoveProd, setToRemoveProd] = React.useState([])
  const [loadDataState, setloadDataState] = useState(false)
  const [getId, setId] = useState(window.location.pathname.split('/')[5])
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })
  const [getSelectedOutlet, setSelectedOutlet] = React.useState('')
  const [getDefaultDecimalPlaces, setDefaultDecimalPlace] = React.useState(2) //api me isko db sy update rakhna hy

  React.useEffect(() => {
    dispatch(setCommonConfigs(PRICEBOOK))
  }, [])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrData(currencyData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (getSearchSelectedProduct) {
        onSelect(getSearchSelectedProduct)
      }
    }
    return () => (mounted = false)
  }, [getSearchSelectedProduct])
  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  // //for common data -> store currency
  // React.useEffect(() => {
  //   let commonData = getReduxCommonSetting;
  //   if (
  //     commonData &&
  //     commonData.storeCommonConfigs &&
  //     commonData.storeCommonConfigs.storeConfig &&
  //     commonData.storeCommonConfigs.storeConfig.currencyData
  //   ) {
  //     let currencyData = commonData.storeCommonConfigs.storeConfig.currencyData;
  //     setCurrData(currencyData);
  //   }
  // }, [getReduxCommonSetting]);

  const scrollArrow = () => {
    if (!scroll && window.pageYOffset > 400) {
      setScroll(true)
    } else if (scroll && window.pageYOffset <= 400) {
      setScroll(false)
    }
  }

  window.addEventListener('scroll', scrollArrow)

  //React.useEffect(() => {
  //    getListingTableData();
  //}, []);

  React.useEffect(() => {
    handleChange()
    //
    //let id = window.location.pathname.split('/')[5];
    //setId(id);
    const unsub = store.subscribe(handleChange)
    ds.getPriceBookData(
      {
        IsPricing: true,
        PriceBookID: getId
      },
      BEHAVIOUR_TYPE.GET
    )
      .then(res => {
        setSpinningLoading(false)
        let prodMapped = res.data.data.productPrices.map(pPrice => {
          return {
            key: getRandomInt(100000000),
            prodPID: pPrice.productPriceID,
            name: `${pPrice.productName} ${
              pPrice.variantName && pPrice.variantName != ''
                ? `(${pPrice.variantName})`
                : ''
            }`,
            supplyprice: pPrice.supplyPrice,
            markup: pPrice.markup,
            discount: pPrice.discount,
            retailprice: pPrice.price,
            minunits: pPrice.minUnits,
            maxunits: pPrice.maxUnits,
            productid: pPrice.productID,
            createdon: pPrice.createdOn,
            salesTax: pPrice.taxValue,
            taxesRevisionList: pPrice.taxesRevisionList,
            originalRetailprice: pPrice.price
          }
        })
        let outMapped = res.data.data.outlets.map(obj => {
          return {
            outID: obj.outletID,
            outName: obj.outletName
          }
        })
        let cusMapped = res.data.data.customers.map(obj => {
          return {
            cusID: obj.customerID,
            cusName: obj.customerGroupName
          }
        })
        let bookMapped = res.data.data.priceBooks.map(obj => {
          return {
            book: obj.bookName,
            cusGroupID: obj.customerGroupID,
            outId: obj.outletID,
            out: obj.outletName,
            cus: obj.customerGroupName,
            validFDate: obj.validFromDate,
            validF: obj.validFrom,
            validT: obj.validTo,
            validTDate: obj.validToDate
          }
        })

        if (bookMapped.length > 0) {
          form.setFieldsValue({ BookName: bookMapped[0].book })
          setBookName(bookMapped[0].book)
          if (!bookMapped[0].validFDate.includes('-')) {
            form.setFieldsValue({
              ValidFrom: moment(bookMapped[0].validFDate, 'dddd, DD MMMM YYYY')
            })
          }
          if (!bookMapped[0].validTDate.includes('-')) {
            form.setFieldsValue({
              ValidTo: moment(bookMapped[0].validTDate, 'dddd, DD MMMM YYYY')
            })
          }
          //form.setFieldsValue({ CustomerGroup: bookMapped[0].cus | bookMapped[0].cusGroupID });
          form.setFieldsValue({
            CustomerGroup: [bookMapped[0].cus, bookMapped[0].cusGroupID]
          })
          form.setFieldsValue({
            Outlets: [bookMapped[0].out, bookMapped[0].outId]
          })
        }
        setOutletData(outMapped)
        setCustomersData(cusMapped)
        prodMapped.sort((a, b) => (a.createdon < b.createdon ? 1 : -1))
        setTableData(prodMapped)
        //history.push(`/Dashboard/products/pricebook/customprices/${id}`);
        //;
        setIsLoading(false)
        if (loadDataState) {
          setloadDataState(false)
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setSpinningLoading(false)
      })

    return () => {
      unsub()
    }
  }, [loadDataState])

  const handleChange = () => {
    if (store.getState().settings.loadData != loadDataState) {
      setloadDataState(store.getState().settings.loadData)
      dispatch(loadData(false))
    }
  }

  //const myRef = useRef(null);

  const onFinishFailed = errorInfo => {
    message.error('Kindly Attend to Wrong Input')
  }

  const onFinish = async values => {
    // ;
    //Object.size = function (obj) {
    //    var size = 0, key;
    //    for (key in obj) {
    //        if (obj.hasOwnProperty(key)) size++;
    //    }
    //    return size;
    //};
    //scroll.current.scrollTo(0, 0);

    // document.body.scrollTop = 0;
    // document.documentElement.scrollTop = 0;
    // window.scrollTo({ top: 0, behavior: "smooth" });
    //scrollToRef(myRef);
    //window.scrollTo(0, 0);
    setSpinningLoading(true)
    setIsProductTableSpinning(true)
    let pKeys = getTableData.map(obj => {
      return { keys: obj.key, proId: obj.productid }
    })
    let priceTab = []

    //filling priceTab for pricing table edit add
    for (let i = 0; i < pKeys.length; i++) {
      let key = pKeys[i].keys
      let prodID = pKeys[i].proId
      let valueArray = []
      let prodObj = {}
      valueArray = Object.entries(values)
      valueArray.forEach(pPrices)

      function pPrices (value) {
        if (value[0].includes(key)) {
          let vKey = value[0]
          let vValue = value[1]
          let prodPId = getTableData.filter(a => a.key === key)

          prodObj.ProductPriceID = prodPId[0].prodPID
          prodObj.PriceBookID = getId
          prodObj.IsRemove = false
          prodObj.ProductID = prodID

          if (vKey.includes(`markup${key}`)) {
            prodObj.MarkUp = parseFloatCustom(vValue)
          } else if (vKey.includes(`discount${key}`)) {
            prodObj.Discount = parseFloatCustom(vValue)
          } else if (vKey.includes(`min${key}`)) {
            prodObj.MinUnits = parseInt(vValue)
          } else if (vKey.includes(`max${key}`)) {
            prodObj.MaxUnits = parseInt(vValue)
          } else if (vKey.includes(`price${key}`)) {
            prodObj.RetailPrice = parseFloatCustom(vValue)
          }
        }
      }
      priceTab.push(prodObj)
    }

    //filling priceTab for deleting pricProd
    for (let j = 0; j < toRemoveProd.length; j++) {
      let removObj = {}
      removObj.ProductPriceID = toRemoveProd[j].id
      removObj.ProductID = toRemoveProd[j].proid
      removObj.PriceBookID = getId
      removObj.IsRemove = true
      priceTab.push(removObj)
    }

    let addUpdateDeletePriceBook = {
      data: {
        msgCode: '',
        msgDescription: ''
      }
    }
    //;
    await ds
      .addUpdateDeletePriceBook(
        {
          Name: values.BookName,
          ValidFrom:
            values.ValidFrom && values.ValidFrom !== undefined
              ? values.ValidFrom.format()
              : undefined,
          ValidTo:
            values.ValidTo && values.ValidTo !== undefined
              ? values.ValidTo.format()
              : undefined,
          // ValidFrom:
          //   values.ValidFrom !== undefined
          //     ? values.ValidFrom.format("DD/MM/YYYY")
          //     : undefined,
          // ValidTo:
          //   values.ValidTo !== undefined
          //     ? values.ValidTo.format("DD/MM/YYYY")
          //     : undefined,
          CustomerGroupID:
            typeof values.CustomerGroup === 'string'
              ? values.CustomerGroup
              : values.CustomerGroup[1],
          OutletID:
            typeof values.Outlets === 'string'
              ? values.Outlets
              : values.Outlets[1],
          IsPricing: true,
          IsRemove: false,
          PriceBookID: getId,
          ProductPricing: priceTab
        },
        BEHAVIOUR_TYPE.UPDATE
      )
      .then(response => {
        dispatch(loadData(true))
        setSpinningLoading(false)
        setIsProductTableSpinning(false)
        addUpdateDeletePriceBook.data = response.data
        //console.log("hello im here", store.getState().settings);
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setSpinningLoading(false)
        setIsProductTableSpinning(false)
        message.error('Something went wrong...')
        // console.log('CatchAddEditBook', e)
      })

    if (addUpdateDeletePriceBook.data.msgCode == 'GENERAL_SUCCESS') {
      //setSpinningLoading(false);
      message.success('Successfully Updated ' + values.BookName)
      setTimeout(() => {
        setSpinningLoading(false)
        setIsProductTableSpinning(false)
        //history.push(`/Dashboard/products/pricebook/customprices/${id}`);
        //window.location.assign(`/Dashboard/products/pricebook/customprices/${id}`);
      }, 2000)
      //history.push("/Dashboard/products/Brands");
    }

    if (addUpdateDeletePriceBook.data.msgCode == 'GENERAL_ERROR') {
      setSpinningLoading(false)
      setIsProductTableSpinning(false)
      message.error(addUpdateDeletePriceBook.data.msgDescription)
    }
    setTimeout(() => {
      setIsProductTableSpinning(false)
      setSpinningLoading(false)
    }, 2000)
    //setSpinningLoading(false);
  }

  const props = {
    //name: 'file',
    //action: '',
    //headers: {
    //    authorization: 'authorization-text',
    //},
    onChange (info) {
      //if (info.file.status !== 'uploading') {
      //    console.log(info.file, info.fileList);
      //}
      //if (info.file.status === 'done') {
      //    message.success(`${info.file.name} file uploaded successfully`);
      //} else if (info.file.status === 'error') {
      //    message.error(`${info.file.name} file upload failed.`);
      //}
      setTimeout(() => {
        if (info.file.status !== 'uploading') {
          console.log(info.file, info.fileList)
        }
        if (info.file.status === 'done') {
          message.success(`${info.file.name} file uploaded successfully`)
        } else if (info.file.status === 'error') {
          message.error(`${info.file.name} file upload failed.`)
        }
      }, 20000)
    }
  }

  function onChange (date, dateString) {
    //console.log(date, dateString);
  }

  const redirectToImport = () => {
    history.push(`/dashboard/products/pricebook/import/${getId}`)
  }

  const formFields = () => {
    const children = []
    children.push(
      <Col lg={8} md={8} sm={12} xs={24}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`BookName`}
          label={<IntlMessages id='products.addpricebook.name' />}
          rules={[
            {
              required: true,
              message: <IntlMessages id='products.addpricebook.namerequired' />
            }
          ]}
        >
          <Input placeholder='Book Name' />
        </Form.Item>
      </Col>,
      <Col lg={8} md={8} sm={12} xs={24}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`ValidFrom`}
          label={<IntlMessages id='products.pricebook.validfrom' />}
        >
          <DatePicker
            className='gx-mb-3 gx-w-100'
            onChange={onChange}
            inputReadOnly={true}
          />
        </Form.Item>
      </Col>,
      <Col lg={8} md={8} sm={12} xs={24}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`ValidTo`}
          label={<IntlMessages id='products.pricebook.validto' />}
        >
          <DatePicker className='gx-mb-3 gx-w-100' inputReadOnly={true} />
        </Form.Item>
      </Col>,
      <Col lg={8} md={8} sm={12} xs={24}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`CustomerGroup`}
          label={<IntlMessages id='products.addpricebook.customergroup' />}
        >
          <Select showSearch optionFilterProp='children'>
            {getCustomersData &&
              getCustomersData.map((e, key) => {
                return (
                  <Option key={key} value={e.cusID}>
                    {e.cusName}
                  </Option>
                )
              })}
          </Select>
        </Form.Item>
      </Col>,
      <Col lg={8} md={8} sm={12} xs={24}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`Outlets`}
          label={<IntlMessages id='products.addpricebook.outlets' />}
        >
          <Select showSearch optionFilterProp='children'>
            {getOutletData &&
              getOutletData.map((e, key) => {
                return (
                  <Select.Option key={key} value={e.outID}>
                    {e.outName}
                  </Select.Option>
                )
              })}
          </Select>
        </Form.Item>
      </Col>
    )

    return children
  }

  //function asd(e) {
  //
  //}

  const columnsInc = [
    {
      title: <IntlMessages id='products.addeditpriceprod.productsku' />,
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => {
        return (
          <span
            onClick={() =>
              history.push(
                `/dashboard/products/pricebook/productdetail/${record.productid}`
              )
            }
            className='gx-link'
            style={{ fontWeight: '500' }}
          >
            {text}
          </span>
        )
      }
    },
    {
      title: <IntlMessages id='products.addeditpriceprod.supplyprice' />,
      dataIndex: 'supplyprice',
      key: 'supplyprice',
      render: (text, record) => {
        text = text ? customParse(text, getDecimalPlaces) : '0.00'
        return (
          <span>
            <strong>{`${getCurrData.currencyCode} ${text}`}</strong>
          </span>
        )
      }
    },
    {
      title: <IntlMessages id='products.addeditpriceprod.markup' />,
      dataIndex: 'markup',
      key: 'markup',
      render: (text, record) => {
        function putMarkUp () {
          let markName = `markup${record.key}`
          form.setFieldsValue({
            [markName]: record.markup
              ? customParse(record.markup, getDecimalPlaces)
              : 0
          })
        }
        putMarkUp()

        return (
          <Form
            form={form}
            name='pricingForm'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item
              name={`markup${record.key}`}
              // shouldUpdate={(prevValues, curValues) => prevValues.additional !== curValues.additional}
            >
              <InputNumber
                type='number'
                // min={0}
                // max={1000}
                step={0.1}
                onChange={e => onChangeMark(e, record)}
                onFocus={e => e.target.select()}
              />
            </Form.Item>
          </Form>
        )
      }
    },
    {
      title: <IntlMessages id='products.addeditpriceprod.discount' />,
      dataIndex: 'discount',
      key: 'discount',
      render: (text, record) => {
        function putDiscount () {
          let discountName = `discount${record.key}`
          form.setFieldsValue({
            [discountName]: record.discount
              ? customParse(record.discount, getDecimalPlaces)
              : 0
          })
        }
        putDiscount()

        return (
          <Form
            form={form}
            name='pricingForm'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item name={`discount${record.key}`}>
              <InputNumber
                type='number'
                min={0}
                // max={1000}
                step={0.1}
                onChange={e => onChangeDiscount(e, record)}
                onFocus={e => e.target.select()}
              />
            </Form.Item>
          </Form>
        )
      }
    },
    {
      title: <IntlMessages id='products.addeditpriceprod.retailprice' />,
      dataIndex: 'retailprice',
      key: 'retailprice',
      render: (text, record) => {
        function putPrice () {
          let priceName = `price${record.key}`
          form.setFieldsValue({
            [priceName]: record.retailprice
              ? dynamoParse(record.retailprice, 4)
              : 0
          })
        }
        putPrice()

        return (
          <Form
            form={form}
            name='pricingForm'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Tooltip title='READ ONLY (VALUE CANNOT CHANGE)' color='#6f6e6e'>
              <Form.Item name={`price${record.key}`}>
                <InputNumber
                  type='number'
                  min={0}
                  step={0.1}
                  readOnly
                  bordered={false}
                />
              </Form.Item>
            </Tooltip>
          </Form>
        )
      }
    },
    {
      title: <IntlMessages id='products.addeditpriceprod.saletaxinc' />,
      dataIndex: 'salesTax',
      key: 'salesTax',
      render: (text, record) => {
        function putPrice () {
          // const tax = record.retailprice * (record.salesTax / 100);
          const tax = fetchTaxValue(
            record.retailprice,
            record.taxesRevisionList
          )
          const taxName = `salesTax${record.key}`
          form.setFieldsValue({
            [taxName]: tax ? dynamoParse(tax, 3) : 0
          })
        }
        putPrice()
        return (
          <Form
            form={form}
            name='pricingForm'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Tooltip title='READ ONLY (VALUE CANNOT CHANGE)' color='#6f6e6e'>
              <Form.Item name={`salesTax${record.key}`}>
                <InputNumber type="number" min={0} step={0.1} readOnly bordered={false} />
              </Form.Item>
            </Tooltip>
          </Form>
        )
      }
    },
    {
      title: <IntlMessages id='products.addeditpriceprod.retailpriceinc' />,
      dataIndex: 'retailTaxPrice',
      key: 'retailTaxPrice',
      render: (text, record) => {
        function putPrice () {
          // const priceWithTax = record.retailprice + (record.retailprice * record.salesTax) / 100;
          const priceWithTax =
            record.retailprice +
            fetchTaxValue(record.retailprice, record.taxesRevisionList)
          const priceTax = `taxPrice${record.key}`
          form.setFieldsValue({
            [priceTax]: priceWithTax ? dynamoParse(priceWithTax, 3) : 0
          })
        }
        putPrice()

        return (
          <Form
            form={form}
            name='pricingForm'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item name={`taxPrice${record.key}`}>
              <InputNumber
              type="number"
                min={0}
                status='warning'
                // max={1000}
                step={0.1}
                onChange={e => onChangeRetail(e, record)}
                onFocus={e => e.target.select()}
              />
            </Form.Item>
          </Form>
        )
      }
    },

    {
      title: <IntlMessages id='products.brands.delete' />,
      key: 'delete',
      render: (text, record) => {
        return getIsDisableDelete ? (
          <Tag color='#f50'>
            <strong>
              <IntlMessages id='dakarpos.allow.accessdenied' />
            </strong>
          </Tag>
        ) : (
          <span>
            <a
              onClick={() =>
                showDeleteConfirmPro(
                  record.prodPID,
                  record.name,
                  record.productid,
                  record.key
                )
              }
              className='trash-icon-btn'
            >
              <i className='icon icon-trash ' />
            </a>
          </span>
        )
      }
    }
  ]

  function fetchTaxValue (price, taxList) {
    let fixValue = 0
    let percentValue = 0
    let result = 0
    if (taxList && taxList.length > 0) {
      taxList.map(a => {
        if (a.isFix) {
          fixValue += a.value
        } else {
          percentValue += a.value
        }
      })
      result = (price * percentValue) / 100
      result += fixValue
    }
    return result
  }

  function fetchExcludinPriceFromInclusive (price, taxList) {
    let result = price
    if (taxList && taxList.length > 0) {
      let fixValue = 0
      let percentValue = 0
      taxList.map(a => {
        if (a.isFix) {
          fixValue += a.value
        } else {
          percentValue += a.value
        }
      })
      result -= fixValue
      //NOTE: this is the formula to get tax exclusive price from inclusive price
      const helpingPercent = 1 + percentValue / 100
      const taxVal = (result / helpingPercent) * (percentValue / 100)
      result -= taxVal
    }
    return result
  }

  const columnsExc = [
    {
      title: <IntlMessages id='products.addeditpriceprod.productsku' />,
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => {
        return (
          <span
            onClick={() =>
              history.push(
                `/dashboard/products/main/productdetail/${record.productid}`
              )
            }
            className='gx-link'
            style={{ fontWeight: '500' }}
          >
            {text}
          </span>
        )
      }
    },
    {
      title: <IntlMessages id='products.addeditpriceprod.supplyprice' />,
      dataIndex: 'supplyprice',
      key: 'supplyprice',
      render: (text, record) => {
        text = text ? customParse(text, getDecimalPlaces) : '0.00'
        return (
          <span>
            <strong>{`${getCurrData.currencyCode} ${text}`}</strong>
          </span>
        )
      }
    },
    {
      title: <IntlMessages id='products.addeditpriceprod.markup' />,
      dataIndex: 'markup',
      key: 'markup',
      render: (text, record) => {
        function putMarkUp () {
          let markName = `markup${record.key}`
          form.setFieldsValue({
            [markName]: record.markup
              ? customParse(record.markup, getDecimalPlaces)
              : 0
          })
        }
        putMarkUp()

        return (
          <Form
            form={form}
            name='pricingForm'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item
              name={`markup${record.key}`}
              // shouldUpdate={(prevValues, curValues) => prevValues.additional !== curValues.additional}
            >
              <InputNumber
              type="number"
                // min={0}
                // max={1000}
                step={0.1}
                onChange={e => onChangeMark(e, record)}
                onFocus={e => e.target.select()}
              />
            </Form.Item>
          </Form>
        )
      }
    },
    {
      title: <IntlMessages id='products.addeditpriceprod.discount' />,
      dataIndex: 'discount',
      key: 'discount',
      render: (text, record) => {
        function putDiscount () {
          let discountName = `discount${record.key}`
          form.setFieldsValue({
            [discountName]: record.discount
              ? customParse(record.discount, getDecimalPlaces)
              : 0
          })
        }
        putDiscount()

        return (
          <Form
            form={form}
            name='pricingForm'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item name={`discount${record.key}`}>
              <InputNumber
              type="number"
                min={0}
                // max={1000}
                step={0.1}
                onChange={e => onChangeDiscount(e, record)}
                onFocus={e => e.target.select()}
              />
            </Form.Item>
          </Form>
        )
      }
    },
    {
      title: <IntlMessages id='products.addeditpriceprod.retailprice' />,
      dataIndex: 'retailprice',
      key: 'retailprice',
      render: (text, record) => {
        function putPrice () {
          let priceName = `price${record.key}`
          form.setFieldsValue({
            [priceName]: record.retailprice
              ? dynamoParse(record.retailprice, 4)
              : 0
          })
        }
        putPrice()

        return (
          <Form
            form={form}
            name='pricingForm'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item name={`price${record.key}`}>
              <InputNumber
              type="number"
                min={0}
                step={0.1}
                onChange={e => onChangeRetail(e, record)}
                onFocus={e => e.target.select()}
              />
            </Form.Item>
          </Form>
        )
      }
    },
    {
      title: <IntlMessages id='products.brands.delete' />,
      key: 'delete',
      render: (text, record) => {
        return getIsDisableDelete ? (
          <Tag color='#f50'>
            <strong>
              <IntlMessages id='dakarpos.allow.accessdenied' />
            </strong>
          </Tag>
        ) : (
          <span>
            <a
              onClick={() =>
                showDeleteConfirmPro(
                  record.prodPID,
                  record.name,
                  record.productid,
                  record.key
                )
              }
              className='trash-icon-btn'
            >
              <i className='icon icon-trash ' />
            </a>
          </span>
        )
      }
    }
  ]

  function onChangeMark (value, record) {
    let rowKey = record.key
    handleDiscountMarkup(
      true,
      value,
      rowKey,
      // record.salesTax,
      record.taxesRevisionList,
      parseFloatCustom(record.supplyprice)
    )
  }

  function onChangeDiscount (value, record) {
    let rowKey = record.key
    let supposedArr = getTableData
    supposedArr.filter(a => a.key === rowKey)[0].discount = value
    setTableData(supposedArr)
    handleDiscountMarkup(
      false,
      value,
      record.key,
      // record.salesTax,
      record.taxesRevisionList,
      parseFloatCustom(record.supplyprice)
    )
    // handlePricesCalculator("Discount", record.key);
  }

  function onChangeRetail (value, record) {
    let rowKey = record.key
    // let supposedArr = getTableData;
    // supposedArr.filter((a) => a.key === rowKey)[0].retailprice = value;
    // setTableData(supposedArr);
    handleTaxPrice(
      value,
      rowKey,
      // record.salesTax,
      record.taxesRevisionList,
      parseFloatCustom(record.supplyprice)
    )
  }

  function showDeleteConfirmPro (id, name, proid, key) {
    confirm({
      title: 'Are you sure remove this Product?',
      content: `"${name}"`,
      okText: 'Yes',
      cancelText: 'No',
      okButtonProps: { className: 'dk-btn-add close-reg-btn' },
      cancelButtonProps: { className: 'dk-btn-cancel close-reg-btn' },
      onOk () {
        deleteProds(id, proid, key)
      },
      onCancel () {
        //console.log('Cancel');
      }
    })
  }

  const deleteProds = (id, proid, key) => {
    let arr = []
    let obj = {}
    if (id) {
      obj.proid = proid
      obj.id = id
      arr.push(obj)
    }
    setTableData(getTableData.filter(a => a.key !== key))
    setToRemoveProd(toRemoveProd.concat(arr))
  }

  function cancelBook () {
    history.push('/Dashboard/products/pricebook')
  }
  async function deleteBook () {
    setSpinningLoading(true)
    setIsProductTableSpinning(true)
    let addUpdateDeletePriceBook = {
      data: {
        msgCode: '',
        msgDescription: ''
      }
    }
    await ds
      .addUpdateDeletePriceBook(
        {
          IsRemove: true,
          PriceBookID: getId
        },
        BEHAVIOUR_TYPE.DELETE
      )
      .then(response => (addUpdateDeletePriceBook.data = response.data))
      .catch(e => notAllowMsgCheck(e))

    if (addUpdateDeletePriceBook.data.msgCode == 'GENERAL_SUCCESS') {
      message.success(`Price Book "${getBookName}" DELETED`)
      //setSpinningLoading(false);
      setTimeout(() => {
        history.push('/Dashboard/products/pricebook')
      }, 2000)
      //history.push("/Dashboard/products/Brands");
    }

    if (addUpdateDeletePriceBook.data.msgCode == 'GENERAL_ERROR') {
      setSpinningLoading(false)
      setIsProductTableSpinning(false)
      message.error(addUpdateDeletePriceBook.data.msgDescription)
    }
    //setSpinningLoading(false);
  }
  function showDeleteConfirm () {
    confirm({
      title: 'Are you sure delete this Book?',
      content: `"${getBookName}"`,
      okText: 'Yes',
      cancelText: 'No',
      okButtonProps: { className: 'dk-btn-add close-reg-btn' },
      cancelButtonProps: { className: 'dk-btn-cancel close-reg-btn' },
      onOk () {
        deleteBook()
      },
      onCancel () {
        //console.log('Cancel');
      }
    })
  }

  const handleSearch = async value => {
    if (value.length > 1) {
      let nameArray = []
      let searchProdPriceBook = {
        data: {
          msgCode: '',
          msgDescription: ''
        }
      }
      await ds
        .getBookSearchProd(
          `?keys=${value}&outletid=${getSelectedOutlet}&isstock=${true}&isPB=${true}&isVariantProduct=${true}`
        )
        .then(response => (searchProdPriceBook.data = response.data))
        .catch(e => {
          //message.error("Kindly Check Internet Connection...");
          // console.log('handleSearch', e)
        })

      if (searchProdPriceBook.data.msgCode == 'GENERAL_SUCCESS') {
        if (searchProdPriceBook.data.data.length > 0) {
          setSearchProd(getSearchProd.concat(searchProdPriceBook.data.data))
          nameArray = searchProdPriceBook.data.data.map(names => {
            const category = names.productName
            return {
              value: category,
              label: (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between'
                  }}
                >
                  <span
                    style={{
                      backgroundColor: 'lightcyan',
                      fontStyle: 'oblique',
                      fontWeight: 'bolder'
                    }}
                  >
                    <a>{category}</a>
                  </span>
                  <span>
                    <IntlMessages id='products.addeditpriceprod.searchresult' />
                  </span>
                </div>
              )
            }
          })
        }
        setOptions(nameArray)
      }

      if (searchProdPriceBook.data.msgCode == 'GENERAL_ERROR') {
        message.error(searchProdPriceBook.data.msgDescription)
      }
    } else {
      setOptions([])
      setSearchProd([])
    }
  }

  const onSelect = async selectedObj => {
    let newProd = []
    let productID = ''
    if (selectedObj && selectedObj != null) {
      if (selectedObj.productID) {
        productID = selectedObj.productID
      }
    } else {
      productID = ''
    }

    if (!StringIsNullOrEmpty(productID)) {
      // Here we call Details API
      await ds
        .getBookSearchProd(
          `?keys=""&outletid=${getSelectedOutlet}&isstock=${true}&isPB=${true}&isVariantProduct=${true}&productID=${productID}`
        )
        .then(response => {
          const productData = response.data
          if (productData.msgCode == 'GENERAL_SUCCESS') {
            if (productData && productData.data.length > 0) {
              newProd = productData.data.map(obj => {
                return {
                  key: getRandomInt(1000000000000000),
                  name: obj.productName,
                  supplyprice: obj.supplyPrice,
                  markup: obj.markup,
                  discount: obj.discount,
                  retailprice: obj.price,
                  minunits: obj.minUnits,
                  maxunits: obj.maxUnits,
                  productid: obj.productID,
                  salesTax: obj.taxValue,
                  taxesRevisionList: obj.taxesRevisionList,
                  originalRetailprice: obj.price
                }
              })
            }
          }
          if (productData.msgCode == 'GENERAL_ERROR') {
            message.error(productData.msgDescription)
          }
        })
        .catch(e => {
          // console.log("Product Search Issue", e)
        })

      if (newProd.length > 0) {
        let isExist = []
        if (getTableData && getTableData.length > 0) {
          isExist = getTableData.filter(
            x =>
              getDecryptID(x.productid) === getDecryptID(newProd[0].productid)
          )
        }
        if (isExist.length == 0) {
          let supposed = []
          supposed.push(newProd[0])
          setTableData(supposed.concat(getTableData))
        } else {
          message.warn('Product is already in this book')
        }
        dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
      }
    }
  }

  // const onSelect = (value) => {
  //   setselected(value);
  // };
  function addnewProd () {
    if (getSearchProd && getSearchProd.length > 0) {
      let newProd = getSearchProd
        .filter(a => a.productName === selected)
        .map(obj => {
          return {
            key: getRandomInt(1000000000000000),
            name: obj.productName,
            supplyprice: obj.supplyPrice,
            markup: obj.markup,
            discount: obj.discount,
            retailprice: obj.price,
            minunits: obj.minUnits,
            maxunits: obj.maxUnits,
            productid: obj.productID,
            salesTax: obj.taxValue,
            taxesRevisionList: obj.taxesRevisionList,
            originalRetailprice: obj.price
          }
        })
      let isExist = []
      if (getTableData && getTableData.length > 0) {
        isExist = getTableData.filter(x => x.key === newProd[0].key)
      }
      //if (isExist.length > 0  ) {
      //    newProd[0]['key'] = '#' + newProd[0].key;
      //}
      //let supposed = [];
      //supposed.push(newProd[0]);
      //setTableData(supposed.concat(getTableData));
      if (isExist.length === 0) {
        let supposed = []
        supposed.push(newProd[0])
        //supposed.unshift(newProd[0]);
        //supposed.splice(0, 0, newProd[0]);
        //setTableData(supposed);
        //setTableData(getTableData.splice(0, 0, newProd[0]));
        //setTableData([]);
        setTableData(supposed.concat(getTableData))
        //setTableData(getTableData.concat(newProd[0]).sort((a, b) => (a.name > b.name) ? 1 : -1));
        //getTableData.sort((a, b) => (a.name > b.name) ? 1 : -1);
        //getTableData.reverse();
      } else {
        message.warn('Product is already in this book')
      }
    } else {
      message.info('Kindly select Product')
    }
  }

  function handleDiscountMarkup (isMarkup, ee, key, taxValue, supplyPrice) {
    //discount will apply first always then markup on supply price
    const saleTaxName = `salesTax${key}`
    const discountName = `discount${key}`
    const markupName = `markup${key}`
    const basePriceName = `price${key}`
    const taxPriceName = `taxPrice${key}`
    let discount = 0
    let markup = 0
    let basePrice = 0
    let saleTax = 0
    let taxPrice = 0
    const currRetailPrice = form.getFieldValue(basePriceName)
      ? parseFloat(form.getFieldValue(basePriceName))
      : 0
    if (isMarkup) {
      const discountVal = form.getFieldValue(`discount${key}`)
        ? parseFloatCustom(form.getFieldValue(`discount${key}`))
        : 0
      // const discountedPrice = currRetailPrice - (discountVal / 100) * currRetailPrice;
      const discountedPrice = supplyPrice - (discountVal / 100) * supplyPrice
      const finalPrice = discountedPrice + (ee / 100) * discountedPrice
      discount = discountVal
      markup = ee
      // saleTax = (finalPrice * taxValue) / 100;
      saleTax = fetchTaxValue(finalPrice, taxValue)
      basePrice = finalPrice
      taxPrice = finalPrice + saleTax
    } else {
      // const discountedPrice = currRetailPrice - (ee / 100) * currRetailPrice;
      const discountedPrice = supplyPrice - (ee / 100) * supplyPrice
      const markupVal = form.getFieldValue(`markup${key}`)
        ? parseFloatCustom(form.getFieldValue(`markup${key}`))
        : 0
      const finalPrice = discountedPrice + (markupVal / 100) * discountedPrice
      discount = ee
      markup = markupVal
      // saleTax = (finalPrice * taxValue) / 100;
      saleTax = fetchTaxValue(finalPrice, taxValue)
      basePrice = finalPrice
      taxPrice = finalPrice + saleTax
    }
    // form.setFieldsValue({
    //   [saleTaxName]: saleTax ? customParse(saleTax, getDecimalPlaces) : "0.00",
    //   [discountName]: discount
    //     ? customParse(discount, getDecimalPlaces)
    //     : "0.00",
    //   [markupName]: markup ? customParse(markup, getDecimalPlaces) : "0.00",
    //   [basePriceName]: basePrice
    //     ? customParse(basePrice, getDecimalPlaces)
    //     : "0.00",
    //   [taxPriceName]: taxPrice
    //     ? customParse(taxPrice, getDecimalPlaces)
    //     : "0.00",
    // });
    let supposedArr = getTableData
    supposedArr.filter(a => a.key === key)[0].markup = markup ? markup : 0
    supposedArr.filter(a => a.key === key)[0].discount = discount ? discount : 0
    supposedArr.filter(a => a.key === key)[0].retailprice = basePrice
      ? basePrice
      : 0
    setTableData(supposedArr)
    forceUpdate()
  }

  function handleTaxPrice (ee, key, taxValue, supplyPrice) {
    const saleTaxName = `salesTax${key}`
    const discountName = `discount${key}`
    const markupName = `markup${key}`
    const basePriceName = `price${key}`
    const taxPriceName = `taxPrice${key}`
    let discount = 0
    let basePrice = 0
    let saleTax = 0
    let markup = 0
    let taxPrice = 0
    if (!getIsTaxExclusive) {
      ee = fetchExcludinPriceFromInclusive(ee, taxValue)
    }
    basePrice = ee
    const diff = ee - supplyPrice
    if (diff != 0) {
      const da = (diff / supplyPrice) * 100
      markup = da
    }
    // if markup is in negative then its actually a discount
    if (markup < 0) {
      discount = markup * -1
      markup = 0
    }
    let supposedArr = getTableData
    supposedArr.filter(a => a.key === key)[0].markup = markup ? markup : 0
    supposedArr.filter(a => a.key === key)[0].discount = discount ? discount : 0
    supposedArr.filter(a => a.key === key)[0].retailprice = ee
    setTableData(supposedArr)
    forceUpdate()
  }

  // function handleTaxPrice(ee, key, taxValue, supplyPrice) {
  //   const saleTaxName = `salesTax${key}`;
  //   const discountName = `discount${key}`;
  //   const markupName = `markup${key}`;
  //   const basePriceName = `price${key}`;
  //   const taxPriceName = `taxPrice${key}`;
  //   let discount = 0;
  //   let basePrice = 0;
  //   let saleTax = 0;
  //   let markup = 0;
  //   let taxPrice = 0;
  //   if (getIsTaxExclusive) {
  //     basePrice = ee;
  //     const diff = ee - supplyPrice;
  //     if (diff != 0) {
  //       const da = (diff / supplyPrice) * 100;
  //       markup = da;
  //     }
  //   } else {
  //     taxPrice = ee;
  //     const incSupplyPrice = supplyPrice + fetchTaxValue(supplyPrice, taxValue);
  //     const diff = ee - incSupplyPrice;

  //     if (diff != 0) {
  //       const da = (diff / incSupplyPrice) * 100;
  //       markup = da;
  //     }
  //     basePrice = supplyPrice + supplyPrice * (markup / 100);
  //     saleTax = fetchTaxValue(basePrice, taxValue);
  //   }
  //   // if markup is in negative then its actually a discount
  //   if (markup < 0) {
  //     discount = markup * -1;
  //     markup = 0;
  //   }
  //   //////////
  //   // form.setFieldsValue({
  //   //   [saleTaxName]: saleTax ? customParse(saleTax, getDecimalPlaces) : "0.00",
  //   //   [discountName]: discount
  //   //     ? customParse(discount, getDecimalPlaces)
  //   //     : "0.00",
  //   //   [markupName]: markup ? customParse(markup, getDecimalPlaces) : "0.00",
  //   //   [basePriceName]: basePrice
  //   //     ? customParse(basePrice, getDecimalPlaces)
  //   //     : "0.00",
  //   //   [taxPriceName]: taxPrice
  //   //     ? customParse(taxPrice, getDecimalPlaces)
  //   //     : "0.00",
  //   // });
  // }

  return getIsAllowRead ? (
    <div className='Content-wrapper GeneralPriceBook-pg'>
      <div className='align-items-center bread-crum'>
        <i className='icon icon-charvlet-right mr-1 pt-1' />
        <h3 className='mb-0 mr-3'>
          <a
            onClick={() => history.push('/Dashboard/products/main')}
            className='custm-glinkprimaryclr'
          >
            {<IntlMessages id='products.addpricebook.products' />}
          </a>
        </h3>
        <i className='icon icon-charvlet-right mr-1 pt-1' />
        <h3 className='mb-0 mr-3'>
          <a
            onClick={() => history.push('/Dashboard/products/pricebook')}
            className='custm-glinkprimaryclr'
          >
            {<IntlMessages id='products.addpricebook.pricebook' />}
          </a>
        </h3>
        <i className='icon icon-charvlet-right mr-1 pt-1' />
        <h3 className='mb-0 mr-3 dk-dark-black'>
          <a>
            {<IntlMessages id='products.brands.edit' />}
            {` ${getBookName}`}
          </a>
        </h3>
      </div>

      <Spin
        tip={<IntlMessages id='products.addeditpriceprod.savebook' />}
        spinning={isSpinningLoading}
        size='large'
      >
        <Card
          className='gx-card Filters-wrapper No-BoxShadow mt-3'
          title={<><IntlMessages id='products.addeditpriceprod.editpricebook' />   <DuplicatePriceBook PriceBookID={priceBookId} /> </>}
        >
          <Form
            form={form}
            name='advanced_search'
            className='ant-advanced-search-form product-search-form Filters-Form'
            onFinish={onFinish}
          >
            <Row className='edit-pricebook-form'>{formFields()}</Row>
            <AdjustPriceBookPrices PriceBookID={priceBookId} /> 
          </Form>
        </Card>
      </Spin>

      <Spin
        tip={<IntlMessages id='products.addeditpriceprod.saveproductbook' />}
        spinning={isProductTableSpinning}
        size='large'
      >
        <div className='edit-Products-table'>
          <h2 class='mb-3'>
            <IntlMessages id='products.addpricebook.products' />
          </h2>

          <Col lg={24} md={24} sm={24} xs={24}>
            <ProductSearch isLabel={false} noChild={true} />
          </Col>

          {isLoading ? (
            <Skeleton count={7} height={35} />
          ) : (
            <div>
              <Table
                className='gx-table-responsive'
                columns={getIsTaxExclusive ? columnsExc : columnsInc}
                dataSource={getTableData}
              />

              <div className='display-margin-unset'>
                <Form
                  form={form}
                  name='pricingForm'
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  scrollToFirstError
                >
                  <Form.Item>
                    <Button
                      onClick={cancelBook}
                      className='dk-btn-cancel'
                      type='primary'
                      size='large'
                    >
                      <IntlMessages id='products.addpricebook.cancel' />
                    </Button>

                    <Button
                      onClick={showDeleteConfirm}
                      type='primary'
                      className='dk-btn-cancel ml-2 mr-2'
                      size='large'
                      disabled={getIsDisableDelete}
                    >
                      <IntlMessages id='products.promotionlisting.delete' />
                    </Button>

                    <Button
                      className='dk-btn-add'
                      type='primary'
                      htmlType='submit'
                      size='large'
                      disabled={getIsDisableUpdate}
                    >
                      <IntlMessages id='products.promoadd.savbtn' />
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>
          )}
        </div>
      </Spin>
    </div>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default AddEditPriceProd
